import { ref, computed } from 'vue'

export const useTabsMap = () => {
  // Estado reactivo
  const activeTab = ref(0)
  const selectedLocation = ref(null)

  // Configuración de tabs
  const tabs = [
    { id: 'santiago', label: 'R. METROPOLITANA' },
    { id: 'chile', label: 'TODO CHILE' }
  ]

  // Datos de ubicaciones exactos del original
  const ubicacionesData = [
    // Santiago
    {
      id: 'alberto',
      titulo: 'León Maipú',
      img: 'maipu.webp',
      direccion: 'Alberto Llonas 1254, Maipú',
      telefono: '2 2580 5027',
      region: 'metropolitana',
      coordinates: { top: '62%', left: '22%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3326.4456631535004!2d-70.7560376!3d-33.51579679999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662dcd08e86a0b7%3A0xc842eccc6f4c19ce!2sAlberto%20Llona%201254%2C%20Maip%C3%BA%2C%20Santiago%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1678908946985!5m2!1ses-419!2scl",
      link: "https://leon.cl/nuestros-locales/local-maipu",
    },
    {
      id: 'amalia',
      titulo: 'León La Florida',
      img: 'laflorida.webp',
      direccion: 'Av. Santa Amalia 1416, La Florida',
      telefono: '2 2580 5016',
      region: 'metropolitana',
      coordinates: { top: '68%', left: '58%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1662.6906242634077!2d-70.5725728438818!3d-33.543469509677685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d12055e3cdc3%3A0xa324750faa5db21a!2sSta%20Amalia%201416%2C%20La%20Florida%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1612466362240!5m2!1ses-419!2scl",
      link: "https://leon.cl/nuestros-locales/local-laflorida",
    },
    {
      id: 'vicuna',
      titulo: 'León Plaza Vespucio',
      img: 'vicmack.webp',
      direccion: 'Av. Vicuña Mackenna Poniente 6556, La Florida',
      telefono: '2 2580 5044',
      region: 'metropolitana',
      coordinates: { top: '62%', left: '54%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3326.4397502103398!2d-70.60831128503001!3d-33.51595058075529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d065a542548d%3A0x63679b414ca29b1c!2sVicu%C3%B1a%20Mackenna%206556%2C%20La%20Florida%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1636634302083!5m2!1ses-419!2scl",
      link: "https://leon.cl/nuestros-locales/local-vicmack",
    },
    {
      id: 'diagonal',
      titulo: 'León Plaza Egaña',
      img: 'eganav1.webp',
      direccion: 'Av. Irarrázaval 4770 (Esquina Batlle y Ordoñez), Ñuñoa',
      telefono: '2 2580 5070',
      region: 'metropolitana',
      coordinates: { top: '44%', left: '57%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3328.800683799447!2d-70.58048!3d-33.454499000000006!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x32dc24a678073487!2sServicio+Automotriz+Le%C3%B3n+Diagonal+Oriente!5e0!3m2!1sen!2s!4v1431553052948",
      link: "https://leon.cl/nuestros-locales/local-diagonal",
    },
    {
      id: 'irarrazaval',
      titulo: 'León Irarrazaval',
      img: 'irarrazaval.webp',
      direccion: 'Av. Irarrázaval 1518, Ñuñoa',
      telefono: '2 2580 5080',
      region: 'metropolitana',
      coordinates: { top: '46%', left: '49%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6657.561981045219!2d-70.6170708711913!3d-33.45501199907608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf8f2e283213%3A0xa04dd2f1c85576b7!2sNeum%C3%A1ticos%20y%20Bater%C3%ADas%20%7C%20LEON%20Irarr%C3%A1zaval%20Santiago!5e0!3m2!1ses-419!2scl!4v1614017849713!5m2!1ses-419!2scl",
      link: "https://leon.cl/nuestros-locales/local-irarrazaval",
    },
    {
      id: 'colina',
      titulo: 'León Chicureo',
      img: 'chicureo.webp',
      direccion: 'Av. Chicureo km 2,8, Colina',
      telefono: '2 2580 5029',
      region: 'metropolitana',
      coordinates: { top: '13%', left: '54%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d833.8114684007064!2d-70.67300317079406!3d-33.28622999880131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe5c50033da51bf12!2zMzPCsDE3JzEwLjQiUyA3MMKwNDAnMjAuOCJX!5e0!3m2!1ses-419!2scl!4v1636773341671!5m2!1ses-419!2scl",
      link: "https://leon.cl/nuestros-locales/local-chicureo",
    },
    {
      id: 'vitacura',
      titulo: 'León Vitacura',
      img: 'vitacura.webp',
      direccion: 'Av. Vitacura 6390, Vitacura',
      telefono: '2 2580 5050',
      region: 'metropolitana',
      coordinates: { top: '29%', left: '54.5%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3325.385488844214!2d-70.57369778438378!3d-33.543359309673505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d1205680b463%3A0x7dfc5748f6151354!2sSta.%20Amalia%201416%2C%208300211%20Santiago%2C%20La%20Florida%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1677771175871!5m2!1ses!2scl",
      link: "https://leon.cl/nuestros-locales/local-vitacura",
    },
    {
      id: 'cristobal-colon',
      titulo: 'León Colón',
      img: 'colon.webp',
      direccion: 'Av. Cristóbal Colón 6640, Las Condes',
      telefono: '2 2580 5060',
      region: 'metropolitana',
      coordinates: { top: '33%', left: '62%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3330.232359069359!2d-70.559946!3d-33.417186!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfe4527c4213bf15b!2sServicio+Automotriz+Le%C3%B3n+Col%C3%B3n!5e0!3m2!1sen!2s!4v1431552455216",
      link: "https://leon.cl/nuestros-locales/local-colon",
    },
    {
      id: 'las-condes',
      titulo: 'León Estoril',
      img: 'estoril.webp',
      direccion: 'Av. Las Condes 10133, Las Condes',
      telefono: '2 2580 5090',
      region: 'metropolitana',
      coordinates: { top: '27%', left: '69%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3345.3083840805734!2d-71.547664!3d-33.022005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd652795f019801dc!2sServicio+Automotriz+Le%C3%B3n+Vi%C3%B1a+del+Mar!5e0!3m2!1sen!2s!4v1431553288425",
      link: "https://leon.cl/nuestros-locales/local-estoril",
    },
    {
      id: 'penalolen',
      titulo: 'Peñalolén',
      img: 'penalolen.webp',
      direccion: 'Consistorial 5210, Peñalolén',
      telefono: '2 2580 5002',
      region: 'metropolitana',
      coordinates: { top: '50%', left: '80%' },
      mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3327.3100563987978!2d-70.5501441!3d-33.4933094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d1eaa72fb28b%3A0x9e5a5b42b3f9ab2b!2sAv.%20Consistorial%205210%2C%207940669%20Pe%C3%B1alol%C3%A9n%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1755188069979!5m2!1ses-419!2scl',
      link: 'https://leon.cl/nuestros-locales/local-penalolen'
    },
    // Chile
    {
      id: 'vinadelmar',
      titulo: 'Viña del Mar',
      img: 'vina-del-mar.webp',
      direccion: 'Quillota 117, esq. 2 Norte, Viña del Mar',
      telefono: '2 2580 5025',
      region: 'valparaiso',
      coordinates: { top: '34%', left: '43%' },
      mapa: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3345.3083840805734!2d-71.547664!3d-33.022005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd652795f019801dc!2sServicio+Automotriz+Le%C3%B3n+Vi%C3%B1a+del+Mar!5e0!3m2!1sen!2s!4v1431553288425',
      link: 'https://leon.cl/nuestros-locales/local-vina'
    },
    {
      id: 'rancagua',
      titulo: 'Rancagua',
      img: 'rancagua.webp',
      direccion: 'L. Bernardo O\'Higgins 310, Rancagua',
      telefono: '2 2580 5035',
      region: 'ohiggins',
      coordinates: { top: '39%', left: '43%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3301.520448999888!2d-70.763376!3d-34.158609000000006!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x249d1e55683a71dd!2sNeum%C3%A1ticos+y+Bater%C3%ADas+%7C+LEON+Bernardo+O'Higgins+Rancagua!5e0!3m2!1sen!2s!4v1431556178637",
      link: "https://leon.cl/nuestros-locales/local-rancagua",
    },
    {
      id: 'concepcion',
      titulo: 'Concepción',
      img: 'concepcion.png',
      direccion: 'Freire 1, Concepción',
      telefono: '2 2580 5045',
      region: 'biobio',
      coordinates: { top: '47%', left: '41%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1596.7867237786356!2d-73.05937!3d-36.8287401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9669b5dc66ac8847%3A0x11926627e41d130d!2zRnJlaXJlIDEsIDQwMzA2MzIgQ29uY2VwY2nDs24sIELDrW8gQsOtbw!5e0!3m2!1ses!2scl!4v1764943349209!5m2!1ses!2scl",
      link: "https://leon.cl/nuestros-locales/local-concepcion",
    },
    {
      id: 'coquimbo',
      titulo: 'La Serena',
      img: 'laserena.webp',
      direccion: 'Balmaceda 1450, La Serena',
      telefono: '2 2580 5061',
      region: 'coquimbo',
      coordinates: { top: '29%', left: '43%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13833.05961408713!2d-71.251575!3d-29.914275!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9691cbb34d141503%3A0xe04b0ff58669c730!2sLE%C3%93N%20-%20Servicio%20Automotriz%20La%20Serena!5e0!3m2!1ses!2scl!4v1694034093069!5m2!1ses!2scl",
      link: "https://leon.cl/nuestros-locales/local-laserena",
    },
    {
      id: 'puerto-montt',
      titulo: 'Puerto Montt',
      img: 'ptomontt.webp',
      direccion: 'Diego Portales 1330, Puerto Montt',
      telefono: '2 2580 5055',
      region: 'loslagos',
      coordinates: { top: '57%', left: '39%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2989.248348933379!2d-72.95284474858057!3d-41.47721527915423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96183bb23a77a0ed%3A0x4f7ea1ffe1c63b4!2sDiego+Portales+1330%2C+Puerto+Montt%2C+X+Regi%C3%B3n!5e0!3m2!1ses-419!2scl!4v1478881070451",
      link: "https://leon.cl/nuestros-locales/local-puertomontt",
    },
    {
      id: 'antofagasta',
      titulo: 'Antofagasta',
      img: 'antofagasta.webp',
      direccion: 'Simón Bolívar 374, Antofagasta',
      telefono: '2 2580 5015',
      region: 'antofagasta',
      coordinates: { top: '11%', left: '48%' },
      mapa: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3654.8515175676066!2d-70.39653899999999!3d-23.645488!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x453d0a95b9968ba!2sServicio+Automotriz!5e0!3m2!1sen!2s!4v1431553194461",
      link: "https://leon.cl/nuestros-locales/local-antofagasta",
    }
  ]

  // Computed properties
  const ubicacionesSantiago = computed(() => 
    ubicacionesData.filter(loc => loc.region === 'metropolitana')
  )

  const ubicacionesChile = computed(() => 
    ubicacionesData.filter(loc => loc.region !== 'metropolitana')
  )

  // Methods
  const setActiveTab = (index) => {
    activeTab.value = index
    selectedLocation.value = null
    
    // Ocultar panel derecho al cambiar tab
    const contenedorDerecho = document.getElementById('contenedor_derecho')
    if (contenedorDerecho) {
      contenedorDerecho.classList.add('hidden')
    }
    
    // Manejo de tabs como el original
    const tabsContent = document.querySelectorAll('.contenido')
    const tabButtons = document.querySelectorAll('.tabs')
    
    // Remover active de todos los tabs
    tabButtons.forEach(tab => tab.classList.remove('tab-active'))
    
    // Ocultar todo el contenido
    tabsContent.forEach(content => content.classList.add('hidden'))
    
    // Activar el tab seleccionado
    tabButtons[index].classList.add('tab-active')
    tabsContent[index].classList.remove('hidden')
  }

  const selectLocation = (locationId) => {
    const location = ubicacionesData.find(loc => loc.id === locationId)
    selectedLocation.value = location || null
    
    // Mostrar/ocultar panel derecho como el original
    const contenedorDerecho = document.getElementById('contenedor_derecho')
    if (contenedorDerecho) {
      if (location) {
        contenedorDerecho.classList.remove('hidden')
      } else {
        contenedorDerecho.classList.add('hidden')
      }
    }
  }

  // Clases CSS
  const getTabClasses = (index) => [
    'h-[60px] text-xs flex-[1] text-center tabs border-2 rounded-lg border-black p-0 transition',
    'hover:bg-ROJO_LEON hover:text-white hover:border-ROJO_LEON',
    index === 0 ? 'tab-active bg-ROJO_LEON text-white border-ROJO_LEON' : ''
  ]

  const getMarkerClasses = () => [
    'absolute max-w-[240px] group text-sm cursor-pointer ubication-point',
    'transition-transform hover:scale-110 hover:z-20'
  ]

  const getTooltipClasses = (ubicacionId = '') => {
    let topOffset = '-top-12'
    
    // Casos especiales solo para posición vertical
    switch (ubicacionId) {
      case 'vicuna':
        topOffset = '-top-16'
        break
      case 'las-condes':
        topOffset = '-top-16'
        break
      case 'vinadelmar':
        topOffset = '-top-16'
        break
      case 'rancagua':
        topOffset = '-top-16'
        break
      case 'puerto-montt':
        topOffset = '-top-16'
        break
      case 'cristobal-colon':
        topOffset = '-top-16'
        break
      case 'diagonal':
        topOffset = '-top-16'
        break
        
    }
    
    return [
      'group-hover:block hidden absolute',
      topOffset,
      '-translate-x-1/4 bg-white shadow-md py-1 px-2 w-[240px] rounded-lg text-start z-10'
    ]
  }

  return {
    selectedLocation,
    tabs,
    ubicacionesSantiago,
    ubicacionesChile,
    setActiveTab,
    selectLocation,
    getTabClasses,
    getMarkerClasses,
    getTooltipClasses
  }
}